/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  DeferredCostConfigCreateOrUpdateRequest,
  DeferredCostConfigDeleteRequest,
  DeferredCostConfigDto,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class DeferredCostConfigController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags deferred-cost-config-controller
   * @name Get2
   * @request GET:/api/v1/deferred-costs-config/{itemId}
   */
  get = (itemId: string, params: RequestParams = {}) =>
    this.http.request<DeferredCostConfigDto, any>({
      path: `/v1/deferred-costs-config/${itemId}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getPath = '/v1/deferred-costs-config/${itemId}'
  static getMethod = 'GET'
  /**
   * No description
   *
   * @tags deferred-cost-config-controller
   * @name Update3
   * @request PUT:/api/v1/deferred-costs-config/{itemId}
   */
  update = (
    itemId: string,
    data: DeferredCostConfigCreateOrUpdateRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<DeferredCostConfigDto, any>({
      path: `/v1/deferred-costs-config/${itemId}`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updatePath = '/v1/deferred-costs-config/${itemId}'
  static updateMethod = 'PUT'
  /**
   * No description
   *
   * @tags deferred-cost-config-controller
   * @name Create1
   * @request POST:/api/v1/deferred-costs-config/{itemId}
   */
  create = (
    itemId: string,
    data: DeferredCostConfigCreateOrUpdateRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<DeferredCostConfigDto, any>({
      path: `/v1/deferred-costs-config/${itemId}`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createPath = '/v1/deferred-costs-config/${itemId}'
  static createMethod = 'POST'
  /**
   * No description
   *
   * @tags deferred-cost-config-controller
   * @name Delete
   * @request DELETE:/api/v1/deferred-costs-config/{itemId}
   */
  delete = (itemId: string, data: DeferredCostConfigDeleteRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/deferred-costs-config/${itemId}`,
      method: 'DELETE',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static deletePath = '/v1/deferred-costs-config/${itemId}'
  static deleteMethod = 'DELETE'
}
